import * as React from 'react';
import { useRef, useState } from 'react';


import 'css!./__styles__/CareerPlansSocialProof';

type Props = {
  socialProofStatisticsSource: string;
  socialProofStatisticsSourceDescription: string;
};

const CareerPlansToggletip = ({ socialProofStatisticsSource, socialProofStatisticsSourceDescription }: Props) => {
  const hoverStateRef = useRef<string>('');
  const delay = 100;
  const [show, setShow] = useState(false);
  const timeout = useRef<any>(null);

  const handleShow = () => {
    window.clearTimeout(timeout.current);
    hoverStateRef.current = 'show';
    if (!delay) {
      setShow(true);
      return;
    }
    timeout.current = window.setTimeout(() => {
      if (hoverStateRef.current === 'show') setShow(true);
    }, delay);
  };
  const handleHide = () => {
    window.clearTimeout(timeout.current);
    hoverStateRef.current = 'hide';
    if (!delay) {
      setShow(false);
      return;
    }
    timeout.current = window.setTimeout(() => {
      if (hoverStateRef.current === 'hide') setShow(false);
    }, delay);
  };
  const handleFocus = () => {
    handleShow();
  };
  const handleBlur = () => {
    handleHide();
  };
  const handleClick = () => {
    setShow(!show);
  };
  const handleKeyDown = (e: $TSFixMe) => {
    if (e.key === 'Escape') handleHide();
  };

  return (
    <span className="toggletip-container">
      <button
        role="button"
        onClick={handleClick}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        onMouseOver={handleShow}
        onMouseOut={handleHide}
        className="nostyle careerPlansSocialProof-toolTip--text"
        aria-describedby="toggletip-id"
      >
        {socialProofStatisticsSource}
      </button>
      {show && (
        <span id="toggletip-id" role="tooltip" aria-live="polite" className="toggletip-bubble">
          {socialProofStatisticsSourceDescription}
        </span>
      )}
    </span>
  );
};

export default CareerPlansToggletip;
